/** 
  * @class Image Resource Class for Fallback or ImageConversion Images
  * @extends SSImageResource
  * @param {Object} config An options hash with settings for the Resource
  */
import SSImageResource from './001-slideshare_image_resource';

function SSFallbackImageResource(config){
  
  this.resourceTemplate = {
    prefix: config.baseUrl,
    digitLength: 1,
    cacheable: true,
    retries : 0,
    isCritical: true
  };
  this.useTimeStamp = true;
  SSImageResource.call(this,config);
  
}

SSFallbackImageResource.prototype = new SSImageResource();

SSFallbackImageResource.prototype._generateUrl = function(index, size, quality){
  return this.config.baseUrl + '/' + quality + '/slide-' + index + 
    '-' + size + '.jpg?' + this.config.timestamp;
};


SSFallbackImageResource.prototype._generatePrivateUrl = function(index, size, quality){
  // TEMP FIX FOR PRIVATE DOCS
  if (typeof this.config.privateImageSignatures === "undefined") {
    return "";
  }
  return this.config.baseUrl + '%2F' + quality + '%2Fslide-' + index + '-' + size +
   '.jpg' +  this.config.privateImageSignatures[size][quality].url;
};


/**
  * Gets the a list of widths and their suffixes, ie the different versions available
  * @private
  * @return {Object} Returns a list of width, version object pairs
  * @todo candidate for moving into SSImageResource class
  */
SSFallbackImageResource.prototype._getSuffixes = function(){
  var suffixes = [];
  var imageVersions = this.imageVersions;
  
  var i, width, suffix, qualities, quality, qualityLen;
  
  for (width in imageVersions){
    if (!imageVersions.hasOwnProperty(width)){
      continue;
    }
    width = parseInt(width, 10);
    
    qualities = imageVersions[width];
    suffixes[width] = [];
    qualityLen = qualities.length;
    
    for (i=0; i<qualityLen; i++){
      quality = parseInt(qualities[i],10);
      suffix = {
        url : this._generateUrl(this.indexString, width, quality),
        status : 'initialized',
        retries : 2        
      };
      suffixes[width][quality] = suffix;
    }
  }
  return suffixes;  
};

SSFallbackImageResource.prototype.addLinks = function(values){
   this.links = values.links || [];
};

SSFallbackImageResource.prototype.addSignature = function(signatures){
  this.config.privateImageSignatures = signatures;
};

export default SSFallbackImageResource;